<div class="date-input date-range-datepicker d-flex align-items-center {{size}}">
	<div class="input-group"
	 [ngClass]="{
        'sourcing-style': adjustStyleTab === 'sourcing',
         'bottom-left-fix': adjustPopupPosition === 'bottom-left', 
        'bottom-right-fix': adjustPopupPosition === 'bottom-right',
         'top-right-fix': adjustPopupPosition === 'top-right'
      }"
	>
		<span (click)="onClear()" class="clear-icon" *ngIf="clearIconType == 'ResetIcon' && inputDate">
			<app-svg iconType="UndoSVG" class="svgIcon">
			</app-svg>
		</span>
		<input name="datepicker" class="input-calendar" [placeholder]="inputLabel" ngbDatepicker [value]="inputDate"
			#datepicker="ngbDatepicker" [autoClose]="'outside'" (dateSelect)="onDateSelection($event)"
			[displayMonths]="2" [dayTemplate]="dayTemplate" [footerTemplate]="footerTemplate" outsideDays="hidden"
			[startDate]="fromDate!" tabindex="-1" readonly="true" 
			/>
		<ng-template #dayTemplate let-date let-focused="focused">
			<span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
				[class.start-date]="isStartDate(date)" [class.end-date]="isEndDate(date)"
				[class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
				(mouseleave)="hoveredDate = null">
				{{ date.day }}
			</span>
		</ng-template>
		<!-- Templates -->
		<ng-template #footerTemplate>
			<hr class="my-0">
			<div class="action-buttons">
				<button class="btn btn-sm btn-gray" (click)="onClear()">Clear</button>
				<button class="btn btn-sm btn-blue" (click)="onApply()" [disabled]="fromDate && !toDate">Apply</button>
			</div>
		</ng-template>
		<button class="btn" (click)="datepicker.toggle()" type="button">
          <!-- <app-svg iconType="DateIcon" class="svgIcon">
          </app-svg> -->
			<img class="hand" src="../../../../assets/SVGIcons/dateIcon.svg" alt="">
		</button>
	</div>
	<span (click)="onClear()" class="lh-1" *ngIf="clearIconType == 'CrossIcon'">
		<app-svg *ngIf="inputDate" iconType="CrossCircle" class="svgIcon">
		</app-svg>
	</span>
</div>